const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 200, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 150, flex: 1 },
  { field: "tempSuccionComp1", headerName: "Temp. Succion Comp 1", minWidth: 150, flex: 1 },
  { field: "tempSuccionComp2", headerName: "Temp. Succion Comp 2", minWidth: 150, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 150, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 150, flex: 1 },
  { field: "tempEvaporadorC1Entrada", headerName: "Temp. Evaporador C1 Entrada", minWidth: 150, flex: 1 },
  { field: "tempEvaporadorC1Salida", headerName: "Temp. Evaporador C1 Salida", minWidth: 150, flex: 1 },
  { field: "tempDescargaCompresor1", headerName: "Temp. Descarga Compresor 1", minWidth: 150, flex: 1 },
  { field: "tempDescargaCompresor2", headerName: "Temp. Descarga Compresor 2", minWidth: 150, flex: 1 },
  { field: "tempEvaporadorC2Entrada", headerName: "Temp. Evaporador C2 Entrada", minWidth: 150, flex: 1 },
  { field: "tempEvaporadorC2Salida", headerName: "Temp. Evaporador C2 Salida", minWidth: 150, flex: 1 },
  { field: "tempNoUtilizada01", headerName: "Temp. No Utilizada 01", minWidth: 150, flex: 1 },
  { field: "tempNoUtilizada02", headerName: "Temp. No Utilizada 02", minWidth: 150, flex: 1 },
  { field: "presionSuccionComp1", headerName: "Presion Succion Comp 1", minWidth: 150, flex: 1 },
  { field: "presionSuccionComp2", headerName: "Presion Succion Comp 2", minWidth: 150, flex: 1 },
  { field: "presionDescargaComp1", headerName: "Presion Descarga Comp 1", minWidth: 150, flex: 1 },
  { field: "presionDescargaComp2", headerName: "Presion Descarga Comp 2", minWidth: 150, flex: 1 },
  { field: "voltajeCmp1", headerName: "Voltaje Cmp 1", minWidth: 150, flex: 1 },
  { field: "voltajeCmp2", headerName: "Voltaje Cmp 2", minWidth: 150, flex: 1 },
  { field: "amperajeCmp1", headerName: "Amperaje Cmp 1", minWidth: 150, flex: 1 },
  { field: "amperajeCmp2", headerName: "Amperaje Cmp 2", minWidth: 150, flex: 1 },
  { field: "sobrecalentamientoCmp1", headerName: "Sobrecalentamiento Cmp 1", minWidth: 150, flex: 1 },
  { field: "sobrecalentamientoCmp2", headerName: "Sobrecalentamiento Cmp 2", minWidth: 150, flex: 1 },
  { field: "condicionActualComp1", headerName: "Condicion Actual Comp 1", minWidth: 150, flex: 1 },
  { field: "condicionActualComp2", headerName: "Condicion Actual Comp 2", minWidth: 150, flex: 1 },
  { field: "porcentajeCargaComp1", headerName: "Porcentaje Carga Comp 1 (%)", minWidth: 150, flex: 1 },
  { field: "porcentajeCargaComp2", headerName: "Porcentaje Carga Comp 2 (%)", minWidth: 150, flex: 1 },
  { field: "leaderSecondaryComp1", headerName: "Leader / Secondary Comp 1", minWidth: 150, flex: 1 },
  { field: "leaderSecondaryComp2", headerName: "Leader / Secondary Comp 2", minWidth: 150, flex: 1 },
  { field: "controlDeCarga", headerName: "Control de Carga", minWidth: 150, flex: 1 },
  { field: "ramploading", headerName: "Ramploading", minWidth: 150, flex: 1 },
  { field: "bajoNivelAceiteComp1", headerName: "Bajo Nivel Aceite Comp. 1", minWidth: 150, flex: 1 },
  { field: "bajoNivelAceiteComp2", headerName: "Bajo Nivel Aceite Comp. 2", minWidth: 150, flex: 1 },
  { field: "switchFlujoAguaCondensacion", headerName: "Switch Flujo Agua Condensacion", minWidth: 150, flex: 1 },
  { field: "input03", headerName: "Input_03", minWidth: 150, flex: 1 },
  { field: "statusTempMotorComp1", headerName: "Status Temp Motor Comp. 1", minWidth: 150, flex: 1 },
  { field: "statusTempMotorComp2", headerName: "Status Temp Motor Comp. 2", minWidth: 150, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp. 1", minWidth: 150, flex: 1 },
  { field: "interlockComp2", headerName: "Interlock Comp. 2", minWidth: 150, flex: 1 },
  { field: "statusMotorProtect1", headerName: "Status MotorProtect 1", minWidth: 150, flex: 1 },
  { field: "statusMotorProtect2", headerName: "Status MotorProtect 2", minWidth: 150, flex: 1 },
  { field: "arranqueRemoto", headerName: "Arranque Remoto", minWidth: 150, flex: 1 },
  { field: "paroDeEmergencia", headerName: "Paro de Emergencia", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor1", headerName: "Encendido Compresor 1", minWidth: 150, flex: 1 },
  { field: "encendidoCompresor2", headerName: "Encendido Compresor 2", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula1Comp1", headerName: "Load/Unload Valvula 1 Comp. 1", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula2Comp1", headerName: "Load/Unload Valvula 2 Comp. 1", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula3Comp1", headerName: "Load/Unload Valvula 3 Comp. 1", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula1Comp2", headerName: "Load/Unload Valvula 1 Comp. 2", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula2Comp2", headerName: "Load/Unload Valvula 2 Comp. 2", minWidth: 150, flex: 1 },
  { field: "loadUnloadValvula3Comp2", headerName: "Load/Unload Valvula 3 Comp. 2", minWidth: 150, flex: 1 },
  { field: "output08", headerName: "Output_08", minWidth: 150, flex: 1 },
  { field: "output09", headerName: "Output_09", minWidth: 150, flex: 1 },
  { field: "output10", headerName: "Output_10", minWidth: 150, flex: 1 },
  { field: "output11", headerName: "Output_11", minWidth: 150, flex: 1 },
  { field: "output12", headerName: "Output_12", minWidth: 150, flex: 1 },
  { field: "output13", headerName: "Output_13", minWidth: 150, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla1", headerName: "Numero de Falla 1", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla2", headerName: "Numero de Falla 2", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla3", headerName: "Numero de Falla 3", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla4", headerName: "Numero de Falla 4", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 180, flex: 0.5 },
  { field: "numeroFalla5", headerName: "Numero de Falla 5", minWidth: 150, flex: 0.5 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 300, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 300, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempSuccionComp1: row["Temp. Succion Comp 1"],
  tempSuccionComp2: row["Temp. Succion Comp 2"],
  tempProcesoEntrada: row["Temp. Proceso Entrada"],
  tempProcesoSalida: row["Temp. Proceso Salida"],
  tempEvaporadorC1Entrada: row["Temp. Evaporador C1 Entrada"],
  tempEvaporadorC1Salida: row["Temp. Evaporador C1 Salida"],
  tempDescargaCompresor1: row["Temp. Descarga Compresor 1"],
  tempDescargaCompresor2: row["Temp. Descarga Compresor 2"],
  tempEvaporadorC2Entrada: row["Temp. Evaporador C2 Entrada"],
  tempEvaporadorC2Salida: row["Temp. Evaporador C2 Salida"],
  tempNoUtilizada01: row["Temp. No Utilizada 01"],
  tempNoUtilizada02: row["Temp. No Utilizada 02"],
  presionSuccionComp1: row["Presion Succion Comp 1"],
  presionSuccionComp2: row["Presion Succion Comp 2"],
  presionDescargaComp1: row["Presion Descarga Comp 1"],
  presionDescargaComp2: row["Presion Descarga Comp 2"],
  voltajeCmp1: row["Voltaje Cmp 1"],
  voltajeCmp2: row["Voltaje Cmp 2"],
  amperajeCmp1: row["Amperaje Cmp 1"],
  amperajeCmp2: row["Amperaje Cmp 2"],
  sobrecalentamientoCmp1: row["Sobrecalentamiento Cmp 1"],
  sobrecalentamientoCmp2: row["Sobrecalentamiento Cmp 2"],
  condicionActualComp1: row["Condicion Actual Comp 1"],
  condicionActualComp2: row["Condicion Actual Comp 2"],
  porcentajeCargaComp1: row["Porcentaje Carga Comp 1 (%)"],
  porcentajeCargaComp2: row["Porcentaje Carga Comp 2 (%)"],
  leaderSecondaryComp1: row["Leader / Secondary Comp 1"],
  leaderSecondaryComp2: row["Leader / Secondary Comp 2"],
  controlDeCarga: row["Control de Carga"],
  ramploading: row["Ramploading"],
  bajoNivelAceiteComp1: row["Bajo Nivel Aceite Comp. 1"],
  bajoNivelAceiteComp2: row["Bajo Nivel Aceite Comp. 2"],
  switchFlujoAguaCondensacion: row["Switch Flujo Agua Condensacion"],
  input03: row["Input_03"],
  statusTempMotorComp1: row["Status Temp Motor Comp. 1"],
  statusTempMotorComp2: row["Status Temp Motor Comp. 2"],
  interlockComp1: row["Interlock Comp. 1"],
  interlockComp2: row["Interlock Comp. 2"],
  statusMotorProtect1: row["Status MotorProtect 1"],
  statusMotorProtect2: row["Status MotorProtect 2"],
  arranqueRemoto: row["Arranque Remoto"],
  paroDeEmergencia: row["Paro de Emergencia"],
  encendidoCompresor1: row["Encendido Compresor 1"],
  encendidoCompresor2: row["Encendido Compresor 2"],
  loadUnloadValvula1Comp1: row["Load/Unload Valvula 1 Comp. 1"],
  loadUnloadValvula2Comp1: row["Load/Unload Valvula 2 Comp. 1"],
  loadUnloadValvula3Comp1: row["Load/Unload Valvula 3 Comp. 1"],
  loadUnloadValvula1Comp2: row["Load/Unload Valvula 1 Comp. 2"],
  loadUnloadValvula2Comp2: row["Load/Unload Valvula 2 Comp. 2"],
  loadUnloadValvula3Comp2: row["Load/Unload Valvula 3 Comp. 2"],
  output08: row["Output_08"],
  output09: row["Output_09"],
  output10: row["Output_10"],
  output11: row["Output_11"],
  output12: row["Output_12"],
  output13: row["Output_13"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

export const cotherm2compConsultaConfig = {
  title: "COTHERM 2COMP",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/cotherm2comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "CoTherm 2Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};